module.exports = __webpack_public_path__ + "img/update-feed.a27d7644.png";